import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AvatarComponent } from '@app/modules/ui-components/components/avatar/avatar.component';
import { TooltipDirectiveModule } from '@shared/directives/tooltip.directive';
import { PipesModule } from '@shared/pipes/pipes.module';
import { AvatarService } from '@ui-components/components/avatar/services/avatar.service';
import { IconComponent } from '@ui-components/components/icon/icon.component';

import { AvatarSimpleComponent } from './avatar-simple/avatar-simple.component';

@NgModule({
  declarations: [AvatarComponent, AvatarSimpleComponent],
  imports: [CommonModule, PipesModule, IconComponent, TooltipDirectiveModule],
  providers: [AvatarService],
  exports: [AvatarComponent, AvatarSimpleComponent],
})
export class AvatarModule {}
